module.exports = __webpack_public_path__ + "img/xanter-slogan.ea5f9548.svg";